<template>
  <multiselect
    :placeholder="placeholder"
    track-by="id"
    :options="options"
    v-bind="attrs"
    @select="onSelect"
    @remove="onRemove"
    select-label=""
    deselect-label=""
  ></multiselect>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  // Required properties
  props: ["placeholder", "options"],
  components: {
    Multiselect
  },
  computed: {
    // The rest of the attributes
    attrs() {
      const { placeholder, options, select, remove, ...rest } = this.$attrs;
      return rest;
    }
  },
  methods: {
    onSelect(props) {
      this.$emit("on-selected", props);
    },
    onRemove(props) {
      this.$emit("on-removed", props);
    }
  },
  inheritAttrs: false
};
</script>
